
import React, { Dispatch, useState } from "react";
import ReactModal from "react-modal";
import { addComment } from "../../api";

type typeProps = {
    showEditComment: boolean;
    setShowEditComment: Dispatch<React.SetStateAction<boolean>>;
    concretComment: any;
    setConcretComment: Dispatch<React.SetStateAction<any>>;
    getAllClientComments: () => Promise<void>;
    clientId: number
}

function EditComment( { showEditComment, setShowEditComment, concretComment, setConcretComment, getAllClientComments, clientId }: typeProps ) {

    const [newComment, setNewComment] = useState<string | undefined>(concretComment.text);

    const closeWindow = () => {
        setConcretComment({});
        setNewComment("");
        setShowEditComment(false);
    }

    const submitComment = async () => {
        const requestData = {
            id: concretComment.id,
            clientId: clientId,
            text: newComment
        }
        const responseData = await addComment(requestData);
        if (responseData) {
            await getAllClientComments();
            closeWindow();
        }
    }

    return(
        <ReactModal
            isOpen = { showEditComment }
            onRequestClose = { () => closeWindow() }
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    zIndex: 300,
                },
                content: {
                    width: "80%",
                    maxWidth: '550px',
                    maxHeight: "240px",
                    height: "55vh",
                    border: 'none',
                    margin: "auto",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: "center",
                    justifyContent: "space-evenly",
                }
            }}
        >
            <div className = 'modal-edit-comment-content'>
                Edit a Comment
            </div>
            <input
                className = "type-box-type-input"
                style = {{ width: "80%" }}
                type = "text"
                value = { newComment }
                onChange = { e => setNewComment(e.target.value) }
            />
            <button
                className = "user-pin-code-button"
                style = {{
                    margin: "0 15px"
                }}
                onClick = { submitComment }
            >
                Submit
            </button>
        </ReactModal>
    )
}

export default EditComment